<template>
  <div>
    <div class="tecList wow animate__animated animate__fadeIn">
      <div class="tecItem maria" v-for="item in list" :key="item.key">
        <div class="tec-title">{{ item.title }}</div>
        <div class="tec-desc">{{ item.desc }}</div>
        <div class="tec-img">
          <OssImg class="tec-img" :src="item.imgPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
.tecList {
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .tecItem {
    width: calc(33.3% - 1rem);
    box-sizing: border-box;
    height: 234px;
    background-color: #fff;
    padding-left: 16px;
    padding-top: 24px;
    margin-bottom: 24px;
    position: relative;
    border-radius: .5rem;

    .tec-title {
      color: #424242;
      margin-bottom: 16px;
      font-weight: 500;
      font-size: 16px;
    }

    .tec-desc {
      color: #888888;
      font-weight: 500;
      font-size: 14px;
    }

    .tec-img {
      position: absolute;
      right: 0px;
      bottom: 0px;
      width: 7.5rem;
      height: 7.5rem;
    }
  }
}
</style>
